import { useState } from 'react';

interface UseTextValidationReturn {
    sanitizeText: (value: string, context?: string) => string;
    showWarning: boolean;
    warningMessage: string;
}

export const useTextValidation = (): UseTextValidationReturn => {
    const [showWarning, setShowWarning] = useState<boolean>(false);
    const [warningMessage, setWarningMessage] = useState<string>('');

    const sanitizeText = (text: string): string => {
        return text.replace(/[^A-Za-zÁÉÍÓÚáéíóúÑñ\s]/g, '');
    };
    const validateAndSanitize = (value: string, context: string = 'escribir'): string => {
        const sanitized = sanitizeText(value);
        return sanitized;
    };
    return {
        sanitizeText: validateAndSanitize,
        showWarning,
        warningMessage,

    };
};
